module.exports = __webpack_public_path__ + "static/media/light-diff.2c249817.svg";